<div>
  <app-header></app-header>
  <app-title></app-title>
  <app-summary></app-summary>
  <app-work></app-work>
  <app-skill></app-skill>
  <app-education></app-education>
  <app-footer></app-footer>
  <app-signature></app-signature>
</div>

<router-outlet></router-outlet>
